import { DateRangeBucketKey, GetDashboardDataResponse } from '@navstation-portal/reporting/data-model/crew-dashboard';
import { type } from '@ngrx/signals';
import { eventGroup } from '@ngrx/signals/events';
import { CREW_DASHBOARD_STORE_ID } from './constants';

export const crewDashboardEvents = eventGroup({
  source: CREW_DASHBOARD_STORE_ID,
  events: {
    fetchDashboardData: type<string | undefined>(),
    fetchDashboardDataSuccess: type<GetDashboardDataResponse>(),
    fetchDashboardDataFailed: type<Error>(),
    selectRange: type<DateRangeBucketKey>(),
  },
});
